import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { GetTransactionDashboardTotalCountAmountOutputDto, PaymentGatewayServiceProxy, SubscriptionStartType } from '@shared/service-proxies/service-proxies';
import { ChatSignalrService } from 'app/shared/layout/chat/chat-signalr.service';
import * as moment from 'moment';
import { AppComponentBase } from 'shared/common/app-component-base';
import { SignalRHelper } from 'shared/helpers/SignalRHelper';
import { LinkedAccountsModalComponent } from '@app/shared/layout/linked-accounts-modal.component';
import { UserDelegationsModalComponent } from '@app/shared/layout/user-delegations-modal.component';
import { LoginAttemptsModalComponent } from '@app/shared/layout/login-attempts-modal.component';
import { ChangePasswordModalComponent } from '@app/shared/layout/profile/change-password-modal.component';
import { MySettingsModalComponent } from '@app/shared/layout/profile/my-settings-modal.component';
import { NotificationSettingsModalComponent } from '@app/shared/layout/notifications/notification-settings-modal.component';
import { UserNotificationHelper } from '@app/shared/layout/notifications/UserNotificationHelper';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from './store/TransactionDashboard/transactionDashboard.model';
import { setTransactionsStat } from './store/TransactionDashboard/transactionDashboard.actions';
import { map } from 'rxjs/operators';

@Component({
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less']
})
export class AppComponent extends AppComponentBase implements OnInit {

    subscriptionStartType = SubscriptionStartType;
    theme: string;
    installationMode = true;
    yesterdayData$: Observable<any>;
    today:any = moment.utc();
    lastMonth: any = this.today.clone().subtract(1, 'month');
    startDate = this.lastMonth.clone().startOf('month');
    endDate = this.lastMonth.clone().endOf('month');
    selectedDateRange: moment.Moment[] = [moment().add(-1, 'days'), moment().add(-1, 'day'), moment().subtract(7, 'days'), this.startDate.subtract(8, 'hours').toISOString(), this.endDate.subtract(8, 'hours').toISOString()];


    @ViewChild('loginAttemptsModal', {static: true}) loginAttemptsModal: LoginAttemptsModalComponent;
    @ViewChild('linkedAccountsModal') linkedAccountsModal: LinkedAccountsModalComponent;
    @ViewChild('userDelegationsModal', {static: true}) userDelegationsModal: UserDelegationsModalComponent;
    @ViewChild('changePasswordModal', {static: true}) changePasswordModal: ChangePasswordModalComponent;
    @ViewChild('mySettingsModal', {static: true}) mySettingsModal: MySettingsModalComponent;
    @ViewChild('notificationSettingsModal', {static: true}) notificationSettingsModal: NotificationSettingsModalComponent;
    @ViewChild('chatBarComponent') chatBarComponent;
    isQuickThemeSelectEnabled: boolean = this.setting.getBoolean('App.UserManagement.IsQuickThemeSelectEnabled');
    IsSessionTimeOutEnabled: boolean = this.setting.getBoolean('App.UserManagement.SessionTimeOut.IsEnabled') && this.appSession.userId != null;

    public constructor(
        injector: Injector,
        //private _chatSignalrService: ChatSignalrService,
        private _userNotificationHelper: UserNotificationHelper,
        private _paymentService: PaymentGatewayServiceProxy,
        private store: Store<{ transactionDashboardState: AppState }>
    ) {
        super(injector);
        this.yesterdayData$ = store.select((state)=> state?.transactionDashboardState.yesterdayT);
    }

    ngOnInit(): void {
        this._userNotificationHelper.settingsModal = this.notificationSettingsModal;
        this.theme = abp.setting.get('App.UiManagement.Theme').toLocaleLowerCase();
        this.installationMode = UrlHelper.isInstallUrl(location.href);

        this.registerModalOpenEvents();

        // if (this.appSession.application) {
        //     SignalRHelper.initSignalR(() => { this._chatSignalrService.init(); });
        // }
        this.getTransactionDash();
    }

    getTransactionDash() {
        this.yesterdayData$.pipe(
          map((transactionsDashboard) => {
            return transactionsDashboard})
        ).subscribe((hasStats) => {
          if (!hasStats) {
            const tenantId = this.appSession.tenantId || undefined;
            const dateRanges = [
              { start: moment(this.selectedDateRange[0]).local().startOf('day'), end: moment(this.selectedDateRange[1]).local().endOf('day'), isYesterday: true, isLastMonth: false },
              { start: moment(this.selectedDateRange[2]).local().startOf('day'), end: moment(this.selectedDateRange[1]).local().endOf('day'), isYesterday: false, isLastMonth: false },
              { start: moment(this.selectedDateRange[3]), end: moment(this.selectedDateRange[4]), isYesterday: false, isLastMonth: true }
            ];
    
            dateRanges.forEach(({ start, end, isYesterday, isLastMonth }) => {
              this._paymentService
                .getTransactionDashboardTotalCountAmount(tenantId, undefined, start, end)
                .subscribe((transactionsDashboard: GetTransactionDashboardTotalCountAmountOutputDto[]) => {
                  this.store.dispatch(setTransactionsStat({ transactions: transactionsDashboard, isYesterday, isLastMonth }));
                });
            });
    
          }
        });
      }

    subscriptionStatusBarVisible(): boolean {
        return this.appSession.tenantId > 0 &&
            (this.appSession.tenant.isInTrialPeriod ||
                this.subscriptionIsExpiringSoon());
    }

    subscriptionIsExpiringSoon(): boolean {
        if (this.appSession.tenant.subscriptionEndDateUtc) {
            return moment().utc().add(AppConsts.subscriptionExpireNootifyDayCount, 'days') >= moment(this.appSession.tenant.subscriptionEndDateUtc);
        }

        return false;
    }

    registerModalOpenEvents(): void {
        abp.event.on('app.show.loginAttemptsModal', () => {
            this.loginAttemptsModal.show();
        });

        abp.event.on('app.show.linkedAccountsModal', () => {
            this.linkedAccountsModal.show();
        });

        abp.event.on('app.show.userDelegationsModal', () => {
            this.userDelegationsModal.show();
        });

        abp.event.on('app.show.changePasswordModal', () => {
            this.changePasswordModal.show();
        });

        abp.event.on('app.show.mySettingsModal', () => {
            this.mySettingsModal.show();
        });
    }

    getRecentlyLinkedUsers(): void {
        abp.event.trigger('app.getRecentlyLinkedUsers');
    }

    onMySettingsModalSaved(): void {
        abp.event.trigger('app.onMySettingsModalSaved');
    }
}
